export interface AmenityConfig {
  icon: string;
  label: string;
}

export const AMENITIES_CONFIG: Record<string, AmenityConfig> = {
  wifi: { icon: 'pi pi-wifi', label: 'WiFi' },
  parking: { icon: 'pi pi-car', label: 'Parking' },
  grill: { icon: 'pi pi-sun', label: 'Grill' },
  garden: { icon: 'pi pi-sun', label: 'Ogród' },
  terrace: { icon: 'pi pi-home', label: 'Taras' },
  balcony: { icon: 'pi pi-image', label: 'Balkon' },
  fireplace: { icon: 'pi pi-bolt', label: 'Kominek' },
  air_conditioning: { icon: 'pi pi-cloud', label: 'Klimatyzacja' },
  tv: { icon: 'pi pi-desktop', label: 'TV' },
  sauna: { icon: 'pi pi-star', label: 'Sauna' },
  jacuzzi: { icon: 'pi pi-star-fill', label: 'Jacuzzi' },
  playground: { icon: 'pi pi-users', label: 'Plac zabaw' },
  bikes: { icon: 'pi pi-directions', label: 'Rowery' },
  coffee_machine: { icon: 'pi pi-star', label: 'Ekspres' },
  kitchenette: { icon: 'pi pi-th-large', label: 'Aneks' },
  dishwasher: { icon: 'pi pi-circle', label: 'Zmywarka' }
};
